import { useEffect, useState } from "react";

// Light / Dark mode — preview defaults to light, the live site defaults to dark.
export const IS_PREVIEW = typeof window !== "undefined" && /\.preview\.emergentagent\.com$|^localhost$/.test(window.location.hostname);
const LS = "rosterly_theme";
const EV = "rosterly-theme";
const DEF = IS_PREVIEW ? "light" : "dark";

export const getTheme = () => {
    try { return localStorage.getItem(LS) || DEF; } catch { return DEF; }
};
const apply = (t) => document.documentElement.classList.toggle("theme-light", t === "light");
export const setTheme = (t) => {
    try { localStorage.setItem(LS, t); } catch { /* ignore */ }
    apply(t);
    window.dispatchEvent(new Event(EV));
};
if (typeof document !== "undefined") apply(getTheme());

export function useTheme() {
    const [t, setT] = useState(getTheme);
    useEffect(() => {
        const f = () => setT(getTheme());
        window.addEventListener(EV, f);
        return () => window.removeEventListener(EV, f);
    }, []);
    return t;
}
export const LIGHT_LOGO = "/rosterly-logo-light.png?v=2";
